"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardizeFeature = void 0;
const camelcase_keys_1 = __importDefault(require("camelcase-keys"));
const standardizeFeature = (feature, reassignAttributes = false) => {
    // V2 Fibermap reassigns the API response to `attributes` instead of `properties`
    if (reassignAttributes) {
        feature.attributes = feature.properties;
        delete feature.properties;
        return (0, camelcase_keys_1.default)(feature, { deep: true, stopPaths: ['attributes'] });
    }
    return (0, camelcase_keys_1.default)(feature, { deep: true, stopPaths: ['properties'] });
};
exports.standardizeFeature = standardizeFeature;
//# sourceMappingURL=standardizeFeature.js.map